import { Wrapper } from './ChooseBlockWindow.styled';

interface Props {
  children: React.ReactNode;
}
export const ChooseBlockWindow: React.FC<Props> = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
